import React, { Component } from "react";
import Image from '../global/Image';

export default class PageRetailers extends Component {
	
		
	render() {
		
		let post = this.props.post;
		
		if (post.retailers) {
			
			return (				
				
				<div id="retailers" className="c-retailers">
					<div className="c-retailers__inner">
						{post.rt_heading &&
							<h2 className="c-retailers__heading" dangerouslySetInnerHTML={{__html:post.rt_heading}}></h2>
						}
						<div className="c-retailers__grid">
							{post.retailers.map((retailer,i) =>
								{
									if (retailer.url) {
										return (
											<div className="c-retailers__item">
												<a href={retailer.url} target="_blank" className="c-retailers__item__inner" target="_blank">
													<Image srcset={retailer.srcset} src={retailer.src} />
													<h4 className="c-retailers__item__heading" dangerouslySetInnerHTML={{__html:retailer.text}}></h4>
												</a>
											</div>
										)
									} else {
										return (
											<div className="c-retailers__item">
												<div className="c-retailers__item__inner">
													<Image srcset={retailer.srcset} src={retailer.src} />
													<h4 className="c-retailers__item__heading" dangerouslySetInnerHTML={{__html:retailer.text}}></h4>
												</div>
											</div>
										)
									}
								}
							)}
						</div>
					</div>					
				</div>			
									
			);
			
		} else {
			return null;
		}
	}
}